import {
  FETCH_SHIPPING_BEGIN, FETCH_SHIPPING_SUCCESS, FETCH_SHIPPING_ERROR,
  POST_WITHDRAWAL_SUCCESS, POST_WITHDRAWAL_BEGIN, POST_WITHDRAWAL_ERROR, CHANGE_WITHDRAWAL_MODAL_DISPLAY
} from "../actions/shippingPage";

const initialState = {
  payload: {},
  loading: false,
  shippingAddressesLoading: false,
  error: null,
  withdrawalModalActive: false
};

function mustSelectWithdrawalAddress(shippingMethods, shippingMethodSelected, withdrawalPointsSelected) {
  let mustSelectWithdrawalAddress = [];
  // @ts-ignore
  const uniqueSmIdsSelected = [...new Set(Object.values(shippingMethodSelected).map(sm => sm.id))].filter(x => x);
  for (const smId of uniqueSmIdsSelected) {
    // Shipping method with withdrawal point list is selected but the user does not have selected any point yet
    if (Object.keys(shippingMethods[smId].pointList).length > 0 && !Object.keys(withdrawalPointsSelected).map(key => parseInt(key)).includes(parseInt(smId))) {
      mustSelectWithdrawalAddress[shippingMethods[smId].type] = true;
    } else {
      mustSelectWithdrawalAddress[shippingMethods[smId].type] = false;
    }
  }
  ;

  return mustSelectWithdrawalAddress;
}

function scrollToTop() {
  (document.querySelector('#go-top') as HTMLElement).click();
}

export default function shippingReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_WITHDRAWAL_MODAL_DISPLAY:
      return {
        ...state,
        showWithdrawalModal: action.show
      }
    case FETCH_SHIPPING_BEGIN:
      scrollToTop();

      return {
        ...state,
        loading: true,
        mustSelectWithdrawalAddress: [],
        error: null,
        status: null
      };
    case FETCH_SHIPPING_SUCCESS:
      return {
        ...state,
        payload: action.payload,
        mustSelectWithdrawalAddress: mustSelectWithdrawalAddress(action.payload.shippingMethods, action.payload.shippingMethodSelected, action.payload.withdrawalPointsSelected),
        loading: false,
        status: 200
      };
    case FETCH_SHIPPING_ERROR:
      return {
        ...state,
        payload: {},
        loading: false,
        error: action.error,
        status: action.status
      };
    case POST_WITHDRAWAL_BEGIN:
      return {
        ...state,
        shippingAddressesLoading: true,
        mustSelectWithdrawalAddress: [],
      }
    case POST_WITHDRAWAL_ERROR:
      return {
        ...state,
        shippingAddressesLoading: false,
        mustSelectWithdrawalAddress: mustSelectWithdrawalAddress(action.payload.shippingMethods, action.payload.shippingMethodSelected, action.payload.withdrawalPointsSelected),
        shippingAddressesError: action.error,
        shippingAddressesStatus: action.status
      };
    case POST_WITHDRAWAL_SUCCESS:
      const findWithdrawalAddress = (smId, pointId) => {
        // @ts-ignore
        const point = state.payload.shippingMethods[smId].pointList[pointId];

        return {
          fullName: point.name,
          street: point.address.address1,
          postCode: point.address.zipCode,
          city: point.address.city,
        };
      };

      let addresses = [];

      const newShippingMethodId = Object.keys(action.payload.withdrawalPointsSelected)[0];
      const newAddress = findWithdrawalAddress(newShippingMethodId, action.payload.withdrawalPointsSelected[newShippingMethodId]['id']);

      // Hide customer default shipping address if only withdrawal is selected
      // @ts-ignore
      if (Object.keys(state.payload.shippingMethodSelected).length > 1) {
        // @ts-ignore
        addresses = state.payload.shippingAddresses
        // @ts-ignore
        const previousShippingMethodId = Object.keys(state.payload.withdrawalPointsSelected)[0];
        if (previousShippingMethodId !== undefined) {
          // @ts-ignore
          const oldAddress = findWithdrawalAddress(previousShippingMethodId, state.payload.withdrawalPointsSelected[previousShippingMethodId]['id']);
          // Addresses will filter the previously address chosen. It avoids having the server to call the whole api again to get those addresses
          addresses = addresses.filter(address => {
            return !(address.street === oldAddress.street && address.postCode === oldAddress.postCode && address.city === oldAddress.city);
          });
        }
      }

      addresses.push(newAddress);

      const newState = {
        ...state,
        payload: {
          ...state.payload,
          mustSelectWithdrawalAddress: [],
          shippingAddresses: addresses,
          withdrawalPointsSelected: action.payload.withdrawalPointsSelected
        },
      };

      return {
        ...newState,
        loading: false,
        shippingAddressesLoading: false,
        shippingAddressesError: null
      };
    default:
      return state;
  }
}
